import ExempleReducer from './exempleSlice';

export default {
    exemple: ExempleReducer,
};
